import { authenticatedGet } from './api_service';

const SpaceService = {
  getSpaces: () => {
    return authenticatedGet("/api/spaces/");
  }
}

export default SpaceService;
